import {defineStore} from "pinia";
import {ref} from "vue";

export const useOverlayModalsStore = defineStore('overlayModals', ()=>{
    const modelSearchOpen = ref(false);

    function toggleModelSearchOpen() {
        modelSearchOpen.value = !modelSearchOpen.value;
    }

    function setModelSearchOpen(what) {
        modelSearchOpen.value = what;
    }
    return {modelSearchOpen, setModelSearchOpen, toggleModelSearchOpen}
});
